@if(myButtonService?.buttons$ | async; as btns) {
	@for(btn of btns?.barButtons; track btn) {
		<tilby-general-input-button [btn]="btn" [i]="$index" [buttonFontSize]="16" />
	}
	@if(btns?.panelButtons?.length && checkPanelButtons(btns?.panelButtons)) {
		<tilby-general-input-button-panel [panelButtons]="btns.panelButtons || []" />
	}
}
